// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"db3de712","171":"bc36aaae","443":"3fa9b3b6","895":"4a1e7dd3"}[chunkId] + ".chunk.js";
};